import React, { FunctionComponent, Suspense } from 'react'
import { colors } from '@lmc/common/constants'
import { LinkComponent } from '../../../generic'
import Field from '../../../fields'
import { getNominative } from '../../../../common/utils'

interface TeamMemberEditFormPermissionsProps {
  features: {
    eMAR: boolean
  }
  fields: Record<string, any>
  formId: string
  preferredPeopleNominative: string
  style?: Record<string, any>
  gpConnectEnabled?: boolean
}

const renderEmarAdvert = () => {
  return (
    <div style={styles.emarAdvertContainer}>
      <div style={styles.emarAdvertLabel}>Medication</div>
      <LinkComponent target="_blank" to="/settings/billing">
        eMAR Feature <span className="octicon octicon-chevron-right" />
      </LinkComponent>
    </div>
  )
}

const TeamMemberEditFormPermissions: FunctionComponent<
  TeamMemberEditFormPermissionsProps
> = (props) => {
  const {
    features,
    fields,
    formId,
    preferredPeopleNominative,
    style,
    gpConnectEnabled,
  } = props

  return (
    <div style={style}>
      <div style={{ paddingBottom: 20 }}>
        {features.eMAR ? (
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formId={formId}
              keys="medicationPermission"
              label="Medication"
              options={DEFAULT_RADIO_OPTIONS}
              note={getNote(preferredPeopleNominative)}
              required
              type="radios"
              values={fields}
            />
          </Suspense>
        ) : (
          renderEmarAdvert()
        )}
        {gpConnectEnabled && (
          <div style={{ marginTop: 15 }}>
            <Suspense fallback={<div>Loading...</div>}>
              <Field
                formId={formId}
                keys="gpConnectPermission"
                label="GP Connect Access"
                options={DEFAULT_GP_CONNECT_OPTIONS}
                required
                type="radios"
                values={fields}
              />
            </Suspense>
          </div>
        )}
      </div>
    </div>
  )
}

const getNote = (preferredPeopleNominative: string) =>
  `In the Carer App: Ability to sign medication.\nIn the Care Office: Ability to manage medication for all ${getNominative(
    preferredPeopleNominative,
    'Residents'
  )}.`

const DEFAULT_RADIO_OPTIONS = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
]

const DEFAULT_GP_CONNECT_OPTIONS = [
  { value: true, label: 'Clinical Access' },
  { value: false, label: 'Non-Clinical Access' },
]

const styles = {
  emarAdvertContainer: {
    display: 'flex',
  },
  emarAdvertLabel: {
    fontWeight: 600,
    marginRight: 30,
    minWidth: 160,
  },
  emarAdvertText: {
    color: colors.pink,
  },
}

export default TeamMemberEditFormPermissions
